import React, { FC } from "react"
import { PhotoView } from "../../models/PhotoModel"
import { FigurePhoto } from "./FigurePhoto"
import { EditablePhoto } from "./PhotoLayout"

export const JustifyPhoto: FC<{ photos: PhotoView[] } & EditablePhoto> = ({
  photos,
  editable
}) => {
  const className = ["bl-photo__row-justify-container"].join(" ")

  return (
    <div className="bl-photo">
      <div className={className}>
        {photos.map(photo => (
          <FigurePhoto
            editable={editable}
            key={photo.id}
            id={photo.id}
            url={photo.url}
            thumbnail={photo.thumbnail(400)}
          />
        ))}
      </div>
    </div>
  )
}
